import { GraphQLScalarType } from 'graphql';
import { Kind } from 'graphql/language';
import { prepareResolvers } from '../../campaigns/Create-Campaign/Prepare/gql/Prepare.graphql';
import { detailsResolvers } from '../../campaigns/Create-Campaign/Details/gql/Details.graphql';
import { deliveryResolvers } from '../../campaigns/Create-Campaign/Delivery/gql/Delivery.graphql';
import { summaryResolvers } from '../../campaigns/Create-Campaign/Summary/gql/Summary.graphql';

const scalarDateType = {
  Date: new GraphQLScalarType({
    name: 'Date',
    description: 'Date custom scalar type',
    parseValue(value) {
      return new Date(value); // value from the client
    },
    serialize(value) {
      return value.getTime(); // value sent to the client
    },
    parseLiteral(ast) {
      if (ast.kind === Kind.INT) {
        return new Date(ast.value); // ast value is always in string format
      }
      return null;
    },
  }),
};

const resolvers = {
  scalarDateType,
  Mutation: {
    ...prepareResolvers,
    ...detailsResolvers,
    ...deliveryResolvers,
    ...summaryResolvers,
  },
};

export default resolvers;
